<template>
  <div class="demo-integration">
    <span class="copy-to-clipboard" @click="copyToClipboard">{{
      $t("copy_to_clipboard")
    }}</span>
    <span class="demo-code">
      <pre><code>&lt;link href=&quot;{{assetUrl('css')}}&quot; rel=&quot;stylesheet&quot; /&gt;&lt;datacycle-map-widget api-host=&quot;https://widget-api.datacycle.cloud/&quot; api-endpoint=&quot;{{endpoint}}&quot; app-id=&quot;datacycle-demo&quot; map-width=&quot;100%&quot; map-height=&quot;66vh&quot; locale=&quot;de&quot;/&gt;&lt;script src=&quot;{{assetUrl('js')}}&quot;&gt;&lt;/script&gt;</code></pre>
    </span>

    <pre><code>&lt;link href=&quot;{{assetUrl('css')}}&quot; rel=&quot;stylesheet&quot; /&gt;

    &lt;datacycle-map-widget
      api-host=&quot;<span class="color-blue">https://widget-api.datacycle.cloud/</span>&quot;
      api-endpoint=&quot;<span class="color-pink font-bold">{{endpoint}}</span>&quot;
      app-id=&quot;<span class="color-blue">datacycle-demo</span>&quot;
      map-width=&quot;<span class="color-blue">100%</span>&quot;
      map-height=&quot;<span class="color-blue">66vh</span>&quot;
      locale=&quot;<span class="color-blue">de</span>&quot;
    /&gt;

    &lt;script src=&quot;{{assetUrl('js')}}&quot;&gt;&lt;/script&gt;</code></pre>
  </div>
</template>

<script>
import qs from "qs";
import urlJoin from "url-join";
import $ from "jquery";

export default {
  data: function() {
    return { apiEndpoint: "64eb8b16-ad51-49f6-b7de-f4b687288fb3" };
  },
  computed: {
    endpoint() {
      let urlParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      if (
        urlParams &&
        urlParams.data_cycle_widget &&
        urlParams.data_cycle_widget.endpoint &&
        urlParams.data_cycle_widget.endpoint.length
      )
        return urlParams.data_cycle_widget.endpoint;
      else return this.apiEndpoint;
    }
  },
  methods: {
    assetUrl(type) {
      let url = urlJoin(
        window.location.protocol,
        window.location.host,
        window.location.pathname == "/" ? "" : window.location.pathname,
        type,
        "widget." + type
      );
      return url;
    },
    copyToClipboard(event) {
      event.preventDefault();

      let target = $(event.currentTarget);
      let text = $(".demo-code pre code").text();
      let inp = document.createElement("input");
      document.body.appendChild(inp);
      inp.value = text;
      inp.select();
      document.execCommand("copy", false);
      inp.remove();

      target.text(this.$t("copied_to_clipboard")).addClass("copy-finished");

      setTimeout(
        function() {
          target
            .text(this.$t("copy_to_clipboard"))
            .removeClass("copy-finished");
        }.bind(this),
        1000
      );
    }
  }
};
</script>
